
import { defineComponent, ref, Ref, watch, onMounted, onUnmounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import useGlobalHotkey from '@/hooks/useGlobalHotkey'
import usePasteEvent from '@/hooks/usePasteEvent'

// import EditorHeader from './EditorHeader/index.vue'
import Canvas from './Canvas/index.vue'
import CanvasTool from './CanvasTool/index.vue'
import Thumbnails from './Thumbnails/index.vue'
// import Toolbar from './Toolbar/index.vue'
import Remark from './Remark/index.vue'
import ExportDialog from './ExportDialog/index.vue'

export default defineComponent({
  name: 'editor',
  components: {
    // EditorHeader,
    Canvas,
    CanvasTool,
    Thumbnails,
    // Toolbar,
    Remark,
    ExportDialog,
  },
  setup() {
    const mainStore = useMainStore()
    const slidesStore = useSlidesStore()
    const { dialogForExport, showRemark } = storeToRefs(mainStore)
    const closeExportDialog = () => mainStore.setDialogForExport('')
    const { slides } = storeToRefs(slidesStore)

    const remarkHeight = ref(32)

    const layoutCenterRef: Ref<HTMLDivElement | null> = ref(null)

    const CanvasToolRef = ref<any>(null)
    const layoutCenterWidthValue = ref(0)
    useGlobalHotkey()
    usePasteEvent()

    const handleResize = () => {
      layoutCenterWidthValue.value = layoutCenterRef?.value?.offsetWidth || 0      
      CanvasToolRef.value?.handleLayoutWidthChange(layoutCenterWidthValue.value)
    }
    

    onMounted(() => {
      window.addEventListener('resize', handleResize)
    })
    onUnmounted(() => {
      window.removeEventListener('resize', handleResize)
    })
    return {
      remarkHeight,
      dialogForExport,
      closeExportDialog,
      showRemark,
      layoutCenterRef,
      CanvasToolRef
    }
  },
})
